/**
 * Snap points for the phone detail pages' sheet (hiive, event): collapsed, the
 * sheet overlaps the hero's bottom edge by 10px; expanded, it fills the screen.
 *
 * The hero is 4:5 of the screen WIDTH, so on a screen shorter than that hero —
 * a phone on its side, iPhone Duo closed and rotated (~678 x 466pt: an 847pt
 * hero) — the plain overlap is negative and the sheet, title and all, starts
 * below the screen. The collapsed sheet therefore never shows less than 30% of
 * the screen; on an upright phone the overlap is larger and wins.
 */
export function detailSheetSnapPoints(
  heroHeight: number,
  viewportHeight: number,
): [collapsed: string, expanded: string] {
  const collapsed = Math.max(
    viewportHeight - heroHeight + 10,
    Math.round(viewportHeight * 0.3),
  );
  return [`${collapsed}px`, `${viewportHeight}px`];
}
